import image974 from "./image974.png";
import image979 from "./image979.png";
import image976 from "./image976.png";
import image978 from "./image978.png";

export const Products = [
  { _id: "64df3aec4180b81adfe41d32",
    title: "Neo Water Flow Restrictors (NFR)- 3 to 4LPM",
    image: image978,
    price: 299,
    discountedPrice: 165,
    verified: true,
    rating: "4.9",
    stock:20
  },
  { _id: "64df39704180b81adfe41d0b",
    title: "Anti-Theft Shell Tap Adapter 3 LPM (Pack of 2)",
    image: image979,
    price: 299,
    discountedPrice: 165,
    verified: true,
    rating: "4.9",
    stock:3
  },
  { _id: "64df39704180b81adfe41d0c",
    title: "AirOxy 3 Function Shower Head",
    image: image976,
    price: 299,
    stock:10,
    verified: true,
    rating: "4.9"
  },
  { _id: "64df39704180b81adfe41d0d",
    title: "Dual flow chrome finish jet and eco flow aerator",
    image: image974,
    price: 299,
    discountedPrice: 165,
    verified: false,
    stock:0,
    rating: "4.9"
  },
];

export const categoryDescriptions = {
    "Water Conservation": "Reduce operational costs and environmental footprint with water-saving solutions.",
    "Technology Solutions": "Innovations for efficient operations and water conservation.",
    "Hygiene and Care": "Promote comfort and confidence through hygienic environments.",
    "Innovative Touches": "Versatile solutions for a wide range of applications and diverse customer needs."
  };


  export const dummyUser = {
    _id: "64df3c064180b81adfe41d4b",
    firstName: "Rishita",
    lastName: "Maheshwari",
    email: "maheshwaririshita7@gmail.com",
    
    verified: true,
    token: "hZWFmZmU3NmMiLCJpYXQiOjE2OTIwMzY5",
    
};
